const getFieldName = (field: string, baseView?: FleetOps.BaseView) => {
  if (!baseView) {
    return field;
  }

  const baseViewField = baseView.fields[field];
  if (!baseViewField) {
    return field;
  }

  return baseViewField.nameAlias ? baseViewField.nameAlias : field;
};

export default getFieldName;
